// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"573edd0b","453":"cf7dd50d"}[chunkId] + ".chunk.js";
};